import { __assign } from '../../../../../../../../node_modules/tslib/tslib.es6.js';
import ZigMenu from '../../../../display/ZigMenu/index.js';
import React__default, { useMemo } from 'react';
import SliderFilter from '../../filters/SliderFilter/index.js';
import { DropdownItem } from '../../styles.js';
import { DropdownResetButton } from '../atoms/DropdownResetButton/index.js';
import { DropdownLabel } from '../atoms/DropdownLabel/index.js';
import MobileFilterButton from '../atoms/MobileFilterButton/index.js';
import { useTranslation } from 'react-i18next';

var SliderFilterDropdown = function (_a) {
    var resetFilter = _a.resetFilter, filter = _a.filter, onChange = _a.onChange, _b = _a.minSpace, minSpace = _b === void 0 ? 65 : _b, mobile = _a.mobile, prefixId = _a.prefixId, placement = _a.placement;
    var t = useTranslation("zignaly-ui", { keyPrefix: "ZigFilters" }).t;
    var displayValue = useMemo(function () {
        var _a;
        if (Array.isArray(filter.value)) {
            if (filter.value[0] === null && filter.value[1] === null)
                return t("all");
            else if (filter.value[0] === null)
                return "< ".concat(filter.value[1], "%");
            else if (filter.value[1] === null)
                return "> ".concat(filter.value[0], "%");
            else
                return "".concat(filter.value[0], "%-").concat(filter.value[1], "%");
        }
        return (_a = filter.value) === null || _a === void 0 ? void 0 : _a.toString();
    }, [filter.value]);
    if (mobile) {
        return (React__default.createElement(MobileFilterButton, { filter: filter, onChange: onChange, resetFilter: resetFilter, label: "".concat(filter.label, ": ").concat(displayValue), prefixId: prefixId }));
    }
    return (React__default.createElement(ZigMenu, { id: "".concat(prefixId, "__dropdown-").concat(filter.id), disabled: filter.disabled, component: function (_a) {
            var open = _a.open;
            return (React__default.createElement(DropdownItem, { active: open },
                React__default.createElement(DropdownLabel, { minSpace: minSpace, label: filter.label, value: displayValue })));
        }, placement: placement, options: [
            {
                element: (React__default.createElement(SliderFilter, { filter: __assign(__assign({}, filter), { label: "" }), onChange: function (f) { return onChange(__assign(__assign({}, f), { label: filter.label })); } })),
            },
            { separator: true },
            {
                element: (React__default.createElement(DropdownResetButton, { id: "".concat(prefixId, "__slider-dropdown-").concat(filter.id, "-reset"), onClick: resetFilter })),
            },
        ] }));
};

export { SliderFilterDropdown as default };
